import React from 'react';

import styled from 'styled-components';

import { showDate } from '@libs/NwMoment';

const HorizontalDateContainer = styled.div`
    padding: ${(props) => (props.horizontalPadding ? `${props.horizontalPadding} 0` : '.75rem 0')};
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    text-align: center;
    gap: 0.25rem;
    min-width: ${(props) => (props.minWidth ? props.minWidth : 'auto')};

    .day-name {
        font-size: 1.15rem;
        text-transform: uppercase;
    }
    .day-number {
        font-weight: bold;
        font-size: 1.2rem;
    }
    .month-name {
        font-size: 1.15rem;
        text-transform: uppercase;
    }
    .no-date {
        font-size: ${(props) => props.theme.FontSizeSm};
        text-transform: uppercase;
    }

    &.horizontal-date-container-small {
        padding: ${(props) => (props.horizontalPadding ? `${props.horizontalPadding} 0` : '.25rem 0')};
        .day-name {
            font-size: 1.05rem;
        }
        .day-number {
            font-size: 1.1rem;
        }
        .month-name {
            font-size: 1.05rem;
        }
    }

    &.horizontal-date-container-big {
        gap: 0.4rem;
        .day-name {
            font-size: 1.4rem;
        }
        .day-number {
            font-size: 1.5rem;
        }
        .month-name {
            font-size: 1.4rem;
        }
    }
`;

const HorizontalDate = ({ date, showDay, emptyText, size, minWidth, horizontalPadding }) => {
    let className = 'horizontal-date-container';
    if (size) {
        className += ` horizontal-date-container-${size}`;
    }

    if (date) {
        return (
            <HorizontalDateContainer horizontalPadding={horizontalPadding} className={className} minWidth={minWidth}>
                {showDay && <div className="day-name">{showDate(date, 'weekDay')}</div>}
                <div className="day-number">{showDate(date, 'onlyDay')}</div>
                <div className="month-name">{showDate(date, 'onlyMonth')}</div>
            </HorizontalDateContainer>
        );
    } else {
        return (
            <HorizontalDateContainer horizontalPadding={horizontalPadding} className={className} minWidth={minWidth}>
                <div className="no-date">
                    {emptyText ? (
                        <>{emptyText}</>
                    ) : (
                        <>
                            no
                            <br />
                            date
                        </>
                    )}
                </div>
            </HorizontalDateContainer>
        );
    }
};

export default HorizontalDate;
